import { FaPiggyBank } from "react-icons/fa";
import { RiDraftLine } from "react-icons/ri";
import { fareCodes } from "../schemas/data-types/faresTokens";
import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Offer")
    .icon(FaPiggyBank)
    .child(
      S.list()
        .title("Offers")
        .items([
          S.listItem()
            .title("Offers Per Promo")
            .schemaType("exclusiveOfferPerPromo")
            .child(S.documentTypeList("exclusiveOfferPerPromo").title("Offer")),
          S.listItem()
            .title("Promo Configurations")
            .schemaType("promoConfiguration")
            .child(
              S.documentTypeList("promoConfiguration").title(
                "Promo Configurations"
              )
            )
        ])
    );
